:host {
  display: block;
}

.input-checkbox {
  @apply relative flex items-center box-border cursor-pointer;
  @apply bg-transparent;

  font-family: var(--typography-text-checkbox);
}

.input-checkbox__marker {
  @apply w-5 h-5 box-border rounded border-solid border inline-block;
  @apply transition-colors duration-300;

  /* :after psuedo-element displays tghe checkmark inside the box */
  @apply after:content-[''] after:block after:absolute after:w-[5px] after:h-[10px] after:border-solid after:border-t-0 after:border-l-0 after:border-b-2 after:border-r-2 after:border-b-white after:border-r-white after:left-[7px] after:bottom-[6px] after:rotate-45;
}

.input-checkbox__marker--default {
  background-color: var(--clrs-box-clr-fill-label-text-checkbox-default);
  border-color: var(--clrs-box-clr-stroke-label-text-checkbox-default);
}

.input-checkbox__marker--disabled {
  opacity: var(--op-label-text-checkbox-disabled);
}

.input-checkbox__marker--active {
  background-color: var(--clrs-box-clr-fill-label-text-checkbox-active);
  border-color: var(--clrs-box-clr-stroke-label-text-checkbox-active);
}

.input-checkbox__marker--error {
  border-color: var(--clrs-checkbox-error-text-color);
}

.input-checkbox__overlay {
  @apply w-5 h-5 rounded-full box-border absolute top-0;
  @apply transition ease-in-out duration-200;
}

.input-checkbox__title {
  font-family: var(--typography-text-checkbox);
  font-weight: var(--weight-font-checkbox);

  @apply text-sm font-normal tracking-normal leading-6 whitespace-normal break-words pl-2;
}

.input-checkbox__title--default {
  color: var(--clrs-label-text-checkbox-default);
}

.input-checkbox__title--disabled {
  color: var(--clrs-label-text-checkbox-disabled);
  opacity: var(--op-label-text-checkbox-disabled);
}

.input-checkbox__title--error {
  color: var(--clrs-checkbox-error-text-color);
}

.input-checkbox__error-text {
  color: var(--clrs-checkbox-error-text-color);
  font-family: var(--typography-text-checkbox);
  @apply text-xs pl-7;
}
